import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Select, SelectItem } from "@nextui-org/react";
import toast from "react-hot-toast";
import { getFetcher, postFetcher } from "../../../../../services/api";
import useSWR from "swr";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import useListCompany from "../../../../../hooks/useListCompany";
import ControlledReactSelect from "../../../../elements/ControlledReactSelect";
import { useForm } from "react-hook-form";
import { useEffect } from "react";

export default function ModalGenerateReport({ mutate, setSelectedCompany, setSelectedVehicle, setSelectedPeriod }) {
  const schema = yup.object().shape({
    companyId: yup.string().required("Harus diisi"),
    vehicleId: yup.string().required("Harus diisi"),
    periodId: yup.string().required("Harus diisi"),
  });
  const {
    control,
    handleSubmit,
    watch,
    reset,
    setValue,
    register,
    formState: { isSubmitting, errors },
  } = useForm({ resolver: yupResolver(schema) });
  const companyId = watch("companyId");
  const periodId = watch("periodId");

  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();
  const { data: dataVehicle, isLoading: isLoadingVehicle } = useSWR(companyId ? `/api/vehicles/search?companyId=${companyId}&returnAll=true` : null, getFetcher);
  const { data: dataPeriods, isLoading: isLoadingPeriods } = useSWR(`/api/period/actives`, getFetcher);
  // Konteks pengangkutan: daftar perusahaan disaring ke tipe pengangkut.
  // Tanpa filter, endpoint ini mengembalikan seluruh 8.585 perusahaan
  // (10,2 MB, ~2,5 detik) hanya untuk mengisi satu dropdown.
  const { dataCompany, isLoadingCompany } = useListCompany({ tipePerusahaan: ["Mengangkut B3"], hasIdCompanySimpel: true });

  // Set default period when periods are loaded
  useEffect(() => {
    if (dataPeriods?.data && dataPeriods.data.length > 0 && !periodId) {
      setValue("periodId", dataPeriods.data[0].id);
    }
  }, [dataPeriods, periodId, setValue]);

  function handleOnClose() {
    reset({
      companyId: "",
      vehicleId: "",
      periodId: "",
    });
    onClose();
  }

  async function handleOnSubmit(data) {
    try {
      console.log(data);
      await postFetcher("/api/pelaporan-pengangkutan/create-report-vehicle", data);
      mutate();

      const company = dataCompany?.data?.find((item) => item.id === data.companyId);
      const period = dataPeriods?.data?.find((item) => item.id === data.periodId);

      setSelectedCompany({ value: company.id, label: company.name });
      setSelectedPeriod({ value: period.id, label: period.name });
      setSelectedVehicle(data.vehicleId);
      toast.success("Laporan kendaraan berhasil ditambah!");
      handleOnClose();
    } catch (error) {
      console.error("Error creating report:", error);

      // Tampilkan pesan error dari response API
      let errorMessage = "Gagal tambah laporan kendaraan!";

      if (error.response?.data?.message) {
        // Jika message adalah string
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        }
        // Jika message adalah object dengan multiple errors
        else if (typeof error.response.data.message === "object") {
          const errors = Object.values(error.response.data.message);
          errorMessage = errors.join(", ");
        }
      }
      // Fallback untuk error network atau lainnya
      else if (error.message) {
        errorMessage = error.message;
      }

      toast.error(errorMessage);
    }
  }

  return (
    <>
      <Button size="sm" onPress={onOpen} color="primary" startContent={<ArrowPathIcon className="size-4" />}>
        Generate
      </Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} onClose={handleOnClose} isDismissable={false} isKeyboardDismissDisabled={false}>
        <ModalContent>
          {(onClose) => (
            <form onSubmit={handleSubmit(handleOnSubmit)}>
              <ModalHeader className="flex flex-col gap-1">Generate Laporan Kendaraan</ModalHeader>
              <ModalBody className="flex flex-col gap-3">
                <Select
                  {...register("periodId")}
                  variant="faded"
                  isRequired
                  disallowEmptySelection
                  label="Periode"
                  labelPlacement="outside"
                  placeholder="Pilih Periode..."
                  color={errors.periodId ? "danger" : "default"}
                  isInvalid={errors.periodId}
                  errorMessage={errors.periodId && errors.periodId.message}
                  isLoading={isLoadingPeriods}
                >
                  {dataPeriods?.data?.map((period) => (
                    <SelectItem key={period.id} value={period.id}>
                      {period.name}
                    </SelectItem>
                  ))}
                </Select>

                <ControlledReactSelect control={control} name="companyId" label="Perusahaan" options={dataCompany?.data?.map((item) => ({ value: item.id, label: item.name }))} isLoading={isLoadingCompany} />
                <ControlledReactSelect
                  control={control}
                  name="vehicleId"
                  label="Kendaraan"
                  options={dataVehicle?.vehicles?.map((item) => ({ value: item.id, label: `${item.noPolisi} - ${item.modelKendaraan}` }))}
                  isLoading={isLoadingVehicle}
                />
              </ModalBody>
              <ModalFooter>
                <Button isLoading={isSubmitting} isDisabled={isSubmitting} color="danger" variant="light" onPress={onClose}>
                  Tutup
                </Button>
                <Button isLoading={isSubmitting} isDisabled={isSubmitting} type="submit" color="primary">
                  Simpan
                </Button>
              </ModalFooter>
            </form>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
